(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-categorized/assets/javascripts/map-search-payload-to-object.js') >= 0) return;  svs.modules.push('/widgets/oddset-categorized/assets/javascripts/map-search-payload-to-object.js'); 'use strict';

var createInit;
var isHighlightedLeague;

if (svs.isServer) {
  var initBox = require('../../../../components/sport/match-init-box-light/assets/javascripts/match-init-box.js');

  createInit = initBox.createInit;

  var sportUtils = require('../../../../components/sport/sport-common/assets/javascripts/sport-utils.es6');

  isHighlightedLeague = sportUtils.isHighlightedLeague;
} else {
  createInit = svs.sport.matchInitBoxLight.createInit;
  isHighlightedLeague = svs.sport.sport_common.isHighlightedLeague;
}

var mapSearchPayloadToObject = function mapSearchPayloadToObject(sport) {
  return function (result) {
    if (!result || !result.payload || !result.payload.draw || !result.payload.draw.sport || result.payload.draw.sport.id !== sport) {
      return null;
    }

    var events = result && result.payload && result.payload.draw && Array.isArray(result.payload.draw.events) && result.payload.draw.events.filter(function (event) {
      return event && event.isListEvent;
    });

    if (events.length === 0) {
      return null;
    }

    if (!result || !result.payload || !result.payload.draw || !result.payload.draw.match || !result.payload.draw.match.participants || result.payload.draw.match.participants.length !== 2) {
      return null;
    }

    var participantA = result.payload.draw.match.participants[0].name;
    var participantB = result.payload.draw.match.participants[1].name;
    var leagueName = result.payload.draw.league.uniqueLeagueName;

    if (!leagueName) {
      leagueName = result.payload.draw.league.name;
    }

    return {
      draw: {
        draw: result.payload.draw,
        event: events[0],
        hasLeague: Boolean(result.payload.draw.league),
        isHighLeague: isHighlightedLeague(result.payload.draw.league.id),
        participant_a: participantA,
        participant_b: participantB,
        url: "/oddset/externalplay?draw=".concat(result.payload.draw.id, "&event=").concat(events[0].eventNumber, "&outcome=&addToBetslip=false&search=").concat(encodeURIComponent(leagueName))
      },
      initObject: result.payload.draw ? createInit(result.payload.draw) : null
    };
  };
};

if (svs.isServer) {
  module.exports = mapSearchPayloadToObject;
} else {
  setGlobal('svs.widget.oddset_categorized.mapSearchPayloadToObject', mapSearchPayloadToObject);
}
 })(window);